import { render } from "./App.vue?vue&type=template&id=18c93082"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/frequency-lists/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__